import { z } from 'zod';

export const jobClientFeedbackSchema = z.object({
  job_id: z.number().optional(),
  job_date_id: z.number().optional(),
  feedback: z.string().min(1, { message: "Please provide feedback about the client" }),
  author_id: z.number().optional(),
  overall_client_rating: z.number().int().min(1).max(5).optional(),
  pm_name: z.string().optional(),
  pm_notes: z.string().optional(),
  overall_pm_rating: z.number().int().min(1).max(5).optional(),
});

export type JobClientFeedbackFormValues = z.infer<typeof jobClientFeedbackSchema>;

export const defaultJobClientFeedbackValues: Partial<JobClientFeedbackFormValues> = {
  feedback: '',
  pm_name: '',
  pm_notes: '',
};

export const mapClientFeedbackForBackend = (
  data: Partial<JobClientFeedbackFormValues> & { job_id: number; job_date_id: number },
  authorId: number
): JobClientFeedbackFormValues => {
  return {
    job_id: data.job_id,
    job_date_id: data.job_date_id,
    feedback: data.feedback || '',
    author_id: authorId,
    overall_client_rating: data.overall_client_rating,
    pm_name: data.pm_name,
    pm_notes: data.pm_notes,
    overall_pm_rating: data.overall_pm_rating,
  };
};
